import { render, staticRenderFns } from "./BaseItemProps.vue?vue&type=template&id=d961e978&"
import script from "./BaseItemProps.vue?vue&type=script&lang=js&"
export * from "./BaseItemProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports